exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#password_validation[data-v-7475e849]{display:none;background:#f1f1f1;color:#000;position:relative;padding:20px}#password_validation p[data-v-7475e849]{padding:0 35px;font-size:12px}.valid[data-v-7475e849]{color:green!important}.valid[data-v-7475e849]:before{position:relative;left:-35px;content:\"\\2714\"}.invalid[data-v-7475e849]{color:red!important}.invalid[data-v-7475e849]:before{position:relative;left:-35px;content:\"\\2716\"}", ""]);

// exports
